import React from 'react';
import { X, User, Calendar, BookOpen, Users, DollarSign, FileText, Clock, Minus } from 'lucide-react';

const InvoiceDetailsModal = ({ isOpen, invoice, onClose }) => {
  if (!isOpen || !invoice) return null;

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'submitted':
        return 'bg-yellow-100 text-yellow-800';
      case 'approved':
        return 'bg-green-100 text-green-700';
      case 'hold':
        return 'bg-red-100 text-red-600';
      case 'receipt sent':
        return 'bg-blue-100 text-blue-600';
      case 'processing':
        return 'bg-indigo-100 text-indigo-600';
      case 'payment sent':
        return 'bg-green-200 text-green-800';
      case 'open':
        return 'bg-gray-100 text-gray-700';
      default:
        return 'bg-gray-100 text-gray-700';
    }
  };

  const formatDecimalHoursToTime = (value) => {
  if (value === undefined || value === null || value === "") return null;

  const decimalHours = parseFloat(value);
  if (isNaN(decimalHours) || decimalHours < 0) return null;

  const hours = Math.floor(decimalHours);
  const minutes = Math.round((decimalHours - hours) * 60);

  if (minutes === 60) {
    return `${hours + 1}h 0m`;
  }

  if (hours === 0) return `${minutes}m`;
  if (minutes === 0) return `${hours}h`;

  return `${hours}h ${minutes}m`;
};
  // Calculate total students from studentMap
  // const totalStudents = invoice.studentMap ? 
  //   Object.values(invoice.studentMap).reduce((sum, count) => sum + count, 0) : 
  //   invoice.numberOfStudents || 0;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="flex justify-between items-center p-6 border-b bg-gradient-to-r from-[#FC7A69] to-[#221E45] text-white rounded-t-lg">
          <div>
            <h2 className="text-2xl font-bold">Invoice Details</h2>
            <p className="text-white/80">Invoice #{invoice.inv_no}</p>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-white/20 rounded-full transition-colors"
          >
            <X size={24} />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 space-y-6">
          {/* Basic Information */}
          <div className="grid md:grid-cols-2 gap-6">
            <div className="space-y-4">
              <h3 className="text-lg font-semibold text-gray-800 flex items-center gap-2">
                <User size={20} className="text-[#FC7A69]" />
                Trainer Information
              </h3>
              <div className="bg-gray-50 p-4 rounded-lg space-y-2">
                <div className="flex justify-between">
                  <span className="text-gray-600">Name:</span>
                  <span className="font-medium">{invoice.trainerName || 'N/A'}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">Email:</span>
                  <span className="font-medium text-sm">{invoice.instructor_email}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">Contact:</span>
                  <span className="font-medium">{invoice.instructor_contact || 'N/A'}</span>
                </div>
              </div>
            </div>

            <div className="space-y-4">
              <h3 className="text-lg font-semibold text-gray-800 flex items-center gap-2">
                <FileText size={20} className="text-[#FC7A69]" />
                Invoice Status
              </h3>
              <div className="bg-gray-50 p-4 rounded-lg space-y-2">
                <div className="flex justify-between items-center">
                  <span className="text-gray-600">Status:</span>
                  <span className={`px-3 py-1 rounded-full text-sm font-medium capitalize ${getStatusColor(invoice.status)}`}>
                    {invoice.status}
                  </span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">Date:</span>
                  <span className="font-medium">{invoice.date ? new Date(invoice.date).toLocaleDateString() : 'N/A'}</span>
                </div>
              </div>
            </div>
          </div>

          {/* Course Information */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-gray-800 flex items-center gap-2">
              <BookOpen size={20} className="text-[#FC7A69]" />
              Course Information
            </h3>
            <div className="bg-gray-50 p-4 rounded-lg">
              <div className="grid md:grid-cols-2 gap-4">
                <div className="space-y-2">
                  <div className="flex justify-between">
                    <span className="text-gray-600">Course Name:</span>
                    <span className="font-medium">{invoice.courseName}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600">Batch Number:</span>
                    <span className="font-medium">{invoice.batchNumber1}</span>
                  </div>
                  {/* <div className="flex justify-between">
                    <span className="text-gray-600">Total Students:</span>
                    <span className="font-medium">{totalStudents}</span>
                  </div> */}
                </div>
                <div className="space-y-2">
                  {/* <div className="flex justify-between">
                    <span className="text-gray-600">Classes Conducted:</span>
                    <span className="font-medium">{invoice.classes || 0}</span>
                  </div> */}
                  <div className="flex justify-between">
                    <span className="text-gray-600">MOU Hours:</span>
                    <span className="font-medium">{invoice.numClassesAsMOU || 'N/A'}</span>
                  </div>
                 <div className="flex justify-between">
  <span className="text-gray-600">Attended Hours:</span>
  <span className="font-medium">
    {formatDecimalHoursToTime(invoice.classes) || "N/A"}
  </span>
</div>
                </div>
              </div>
            </div>
          </div>

          {/* Student Details */}
          {invoice.studentMap && Object.keys(invoice.studentMap).length > 0 && (
            <div className="space-y-4">
              <h3 className="text-lg font-semibold text-gray-800 flex items-center gap-2">
                <Users size={20} className="text-[#FC7A69]" />
                Student Details
              </h3>
              <div className="bg-gray-50 p-4 rounded-lg">
                <div className="grid gap-2">
                  {Object.entries(invoice.studentMap).map(([studentName], index) => (
                    <div key={index} className="flex justify-between items-center py-2 border-b border-gray-200 last:border-0">
                      <span className="font-medium">{studentName}</span>
                      {/* <span className="text-sm bg-blue-100 text-blue-800 px-2 py-1 rounded">
                        {attendance}% attendance
                      </span> */}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* Payment Information */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-gray-800 flex items-center gap-2">
              <DollarSign size={20} className="text-[#FC7A69]" />
              Payment Information
            </h3>
            <div className="bg-gray-50 p-4 rounded-lg">
              <div className="grid md:grid-cols-2 gap-4">
                <div className="space-y-2">
                  <div className="flex justify-between">
                    <span className="text-gray-600">Cost as per MOU:</span>
                    <span className="font-medium">₹{invoice.costAsPerMOU || 0}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600">Trainer Asked Payment:</span>
                    <span className="font-medium text-[#FC7A69]">₹{invoice.trainerAskedPayment || 0}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600">Net Payable:</span>
                    <span className="font-medium">₹{invoice.netPayable || 0}</span>
                  </div>
                </div>
                <div className="space-y-2">
                  {/* <div className="flex justify-between">
                    <span className="text-gray-600">Payment Percentage:</span>
                    <span className="font-medium">{invoice.paymentPercentage || 0}%</span>
                  </div> */}
                  <div className="flex justify-between">
                    <span className="text-gray-600">TDS:</span>
                    <span className="font-medium">₹{invoice.tds || 0}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600">TDS Status:</span>
                    <span className={`font-medium ${invoice.tdsStatus === 'Yes' ? 'text-red-600' : 'text-green-600'}`}>
                      {invoice.tdsStatus || 'No'}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

        {/* Additional Information */}
<div className="space-y-4">
  <h3 className="text-lg font-semibold text-gray-800 flex items-center gap-2">
    <Clock size={20} className="text-[#FC7A69]" />
    Additional Information
  </h3>
  <div className="bg-gray-50 p-4 rounded-lg">
    <div className="grid md:grid-cols-2 gap-4">
      <div className="space-y-2">
        <div className="flex justify-between">
          <span className="text-gray-600">Leaves Taken:</span>
          <span className="font-medium">{invoice.leaves || 0}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-600">Leaves Amount Deducted:</span>
          <span className="font-medium">₹{invoice.leavesAmountDeducted || 0}</span>
        </div>
      </div>
    </div>
  </div>
</div>
{/* Remarks Section */}
<div className="space-y-4 mt-6">
  <h3 className="text-lg font-semibold text-gray-800 flex items-center gap-2">
    <span className="text-[#FC7A69]">💬</span>
    Remarks
  </h3>
  <div className="bg-gray-50 p-4 rounded-lg">
    <p className="text-gray-900 font-semibold whitespace-pre-line">
      {invoice.remark && invoice.remark.trim() !== "" ? invoice.remark : "No remarks provided"}
    </p>
  </div>
</div>


        </div>

        {/* Footer */}
        <div className="flex justify-end p-6 border-t bg-gray-50 rounded-b-lg">
          <button
            onClick={onClose}
            className="px-6 py-2 bg-gradient-to-r from-[#FC7A69] to-[#221E45] text-white rounded-lg hover:opacity-90 transition-opacity"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default InvoiceDetailsModal;